/**
 * Environment-aware logging utility.
 *
 * In development: All log methods output to console.
 * In production: Only error logs to console (log/debug/info/warn are no-ops).
 *
 * Additionally, Vite's esbuild.pure config strips console.log/debug/info calls
 * from production bundles entirely (belt and suspenders approach).
 */

const isDev = import.meta.env.DEV;

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

function createLogger() {
    return {
        /** General logging - stripped in production */
        log: isDev ? console.log.bind(console) : noop,
        /** Warning logging - stripped in production */
        warn: isDev ? console.warn.bind(console) : noop,
        /** Error logging - ALWAYS outputs (errors need to be visible) */
        error: console.error.bind(console),
        /** Debug logging - stripped in production */
        debug: isDev ? console.debug.bind(console) : noop,
        /** Info logging - stripped in production */
        info: isDev ? console.info.bind(console) : noop
    };
}

export const logger = createLogger();
